<template>
    <div class="fzxw">
        <div class="content">
            <div class="xq">
                <img class="banner_img" src="../../static/img/chanpin_banner.png" alt="">
                <div class="xq_1 w1200" v-for="(item,i) in xhImg" :key="i" v-if="$route.query.id - 0 === i">
                    <img :src="item.imgs" alt="">
                </div>
                <div class="xq_4 w1200">
                    <h3 v-if="$route.query.id != '3'">03 问题解答</h3>
                    <h3 v-if="$route.query.id === '3'">04 问题解答</h3>
                    <div class="xq_text">
                        <div class="yw" v-for=" (item, i ) in sxwz" :key="i" v-if="$route.query.id === '0'">
                            <h4 class="ytext" @click="active2 = i">
                                <span class="hs">{{item.hs}}</span>
                                <span>{{item.text}}</span>
                            </h4>
                            <p :class="{ click: active2 === i }">
                                <span class="ls">{{item.ls}}</span>
                                <span>{{item.value}}</span>
                            </p>
                        </div>
                        <div class="yw" v-for=" (item, i ) in ywwz" :key="i" v-if="$route.query.id === '1'">
                            <h4 class="ytext" @click="active2 = i">
                                <span class="hs">{{item.hs}}</span>
                                <span>{{item.text}}</span>
                            </h4>
                            <p :class="{ click: active2 === i }">
                                <span class="ls">{{item.ls}}</span>
                                <span>{{item.value}}</span>
                            </p>
                        </div>
                        <div class="yw" v-for=" (item, i ) in jcwz" :key="i" v-if="$route.query.id === '2'">
                            <h4 class="ytext" @click="active2 = i">
                                <span class="hs">{{item.hs}}</span>
                                <span>{{item.text}}</span>
                            </h4>
                            <p :class="{ click: active2 === i }">
                                <span class="ls">{{item.ls}}</span>
                                <span>{{item.value}}</span>
                            </p>
                        </div>
                        <div class="yw" v-for=" (item, i ) in cxwz" :key="i" v-if="$route.query.id === '3'">
                            <h4 class="ytext" @click="active2 = i">
                                <span class="hs">{{item.hs}}</span>
                                <span>{{item.text}}</span>
                            </h4>
                            <p :class="{ click: active2 === i }">
                                <span class="ls">{{item.ls}}</span>
                                <span>{{item.value}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'fzxw',
  components: {
  },
  data () {
    return {
      active3: false,
      active2: null,
      active: 0,
      sxwz: [
        {
          hs: 'Q：',
          text: '此款寿险产品是否必须通过代理人购买？',
          ls: 'A：',
          value: '是的，由于保险产品相对于其他金融产品更为复杂，而代理人具有较为专业的保险知识。可有效帮助客户深入理解保险产品的特征与属性，并根据客户的实际情况量身推荐适合的保险产品。此外，一般来说保险产品是长期金融产品，代理人后续还可长期提供专业便捷的保全、理赔等服务。',
          id: '0'
        },
        {
          hs: 'Q：',
          text: '为什么寿险的保费是不固定的？',
          ls: 'A：',
          value: '此产品是以人的生命为标的的，生命本身是无价的，因此我们无法用一个固定金额为产品标价。',
          id: '0'
        }
      ],
      ywwz: [
        {
          hs: 'Q：',
          text: '此款意外险产品是否必须通过代理人购买？',
          ls: 'A：',
          value: '是的，由于保险产品相对于其他金融产品更为复杂，而代理人具有较为专业的保险知识。可有效帮助客户深入理解保险产品的特征与属性，并根据客户的实际情况量身推荐适合的保险产品。此外，一般来说保险产品是长期金融产品，代理人后续还可长期提供专业便捷的保全、理赔等服务。',
          id: '1'
        },
        {
          hs: 'Q：',
          text: '为什么意外险的保费是不固定的？',
          ls: 'A：',
          value: '此产品是以人的生命为标的的，生命本身是无价的，因此我们无法用一个固定金额为产品标价。',
          id: '1'
        }
      ],
      jcwz: [
        {
          hs: 'Q：',
          text: '此款家财险产品是否必须通过代理人购买？',
          ls: 'A：',
          value: '是的，由于保险产品相对于其他金融产品更为复杂，而代理人具有较为专业的保险知识。可有效帮助客户深入理解保险产品的特征与属性，并根据客户的实际情况量身推荐适合的保险产品。此外，一般来说保险产品是长期金融产品，代理人后续还可长期提供专业便捷的保全、理赔等服务。',
          id: '2'
        },
        {
          hs: 'Q：',
          text: '为什么家财险的保费是不固定的？',
          ls: 'A：',
          value: '此产品是以家庭损失为标的的，每个家庭所受到的问题不同，因此我们无法用一个固定金额为产品标价。',
          id: '2'
        }
      ],
      cxwz: [
        {
          hs: 'Q：',
          text: '此款车险产品是否必须通过代理人购买？',
          ls: 'A：',
          value: '是的，由于保险产品相对于其他金融产品更为复杂，而代理人具有较为专业的保险知识。可有效帮助客户深入理解保险产品的特征与属性，并根据客户的实际情况量身推荐适合的保险产品。此外，一般来说保险产品是长期金融产品，代理人后续还可长期提供专业便捷的保全、理赔等服务。',
          id: '3'
        },
        {
          hs: 'Q：',
          text: '车险与哪些保险公司合作？',
          ls: 'A：',
          value: '太平、天安、人保等20多家公司合作。',
          id: '3'
        }
      ],
      xhImg: [
        {
          imgs: require('../../static/img/xhwb_sx.png'),
          id: '0'
        },
        {
          imgs: require('../../static/img/xhwb_ywx.png'),
          id: '1'
        },
        {
          imgs: require('../../static/img/xhwb_jcx.png'),
          id: '2'
        },
        {
          imgs: require('../../static/img/xhwb_cx.png'),
          id: '3'
        }
      ]
    }
  },
  methods: {
    fsxz () {
      this.active3 ? this.active3 = false : this.active3 = true
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
  mounted() {
      let id = this.$route.query.id
      if(this.isMobile()) {

            this.$router.push({path:'/xhproducts?id=', query: {id:id}})
            } else {
            this.$router.push({path:'/cpxh?page=3&id=', query: {id: id}})
            }
  }
}
</script>
<style lang="scss" scoped>
.fzxw {
    position: relative;
}
.content {
    position: relative;
    max-width: 19.20rem;
    width: 100%;
    margin: 0 auto;
    background-color: #f2f2f2;
    .xq {
        margin: 0 auto;
        background-color: #fff;
        .xq_1 {
            position: absolute;
            width: 12rem;
            background-color: #fff;
            left: 0;
            right: 0;
            margin: 0 auto;
            top: -2.50rem;
            position: relative;
            overflow: hidden;
            z-index: 1;
            img {
                margin: 0 auto;
                float: right;
            }
        }
        .xq_4 {
            position: relative;
            top: -1.30rem;
            background-color: #fffcf9;
            h3 {
                background-color: #de101d;
                height: .7rem;
                line-height: .7rem;
                font-size: .36rem;
                color: #fff;
                padding-left: .35rem;
            }
            .xq_text {
                color: #dc1124;
                width: 11.25rem;
                margin: .25rem auto;
                box-shadow: 0px 0px 6px 5px #fef6e9;
                font-size: .3rem;
                padding-left: .25rem;
                h4 {
                    line-height: .74rem;
                    cursor: pointer;
                }
                .yw {
                    color: #5e5a57;
                    .ls{
                        color: #4d09dc;
                    }
                    .hs{
                        color: #e41726;
                    }
                    p {
                        height: 0;
                        overflow: hidden;
                        transition: all 0.3s;
                    }
                }
                .yw .click {
                    height: auto;
                    overflow: auto;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cpxh.vue